import { render, staticRenderFns } from "./Box7.vue?vue&type=template&id=31b8a2f8&scoped=true&"
import script from "./Box7.vue?vue&type=script&lang=js&"
export * from "./Box7.vue?vue&type=script&lang=js&"
import style0 from "./Box7.vue?vue&type=style&index=0&id=31b8a2f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b8a2f8",
  null
  
)

export default component.exports